import React, { useEffect, useRef, useState } from 'react';
//import porplaceholder from '../img/placeholder.png';
//import lanplaceholder from '../img/lanplace.png';
import porplaceholder from '../img/newplaceholder.png';
import lanplaceholder from '../img/newlanplace.png';

const LazyImg = props => {
    const [inView, setInView] = useState(false);
    const placeholderRef = useRef();
  
    useEffect(() => {
        const config = {
            root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
            rootMargin: '0px',
            threshold: 0
          };
        const observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                setInView(true);
                obs.disconnect();
            }
        }
   },config);
    observer.observe(placeholderRef.current);
    return () => {
        observer.disconnect();
    }
}, []);




const errorimg = (e,altimage,lanplaceholder,porplaceholder) =>{
  
    e.target.src=altimage==="landscape"?lanplaceholder:porplaceholder;

}

return (
    inView  ? <img  {...props} alt={props.alt || ""}    onError={e => errorimg(e,props.orient,lanplaceholder,porplaceholder)} /> : <img {...props} ref={placeholderRef} src={props.orient==="landscape"?lanplaceholder:porplaceholder} alt={props.alt || ""} />
)
};
export default LazyImg;